
import { isAdmin, isSuperAdmin, isMasterAdmin } from './userRoleService';
import { UserRole } from '@/types/userRole';

// Check if a user has access to a specific feature
export const hasAccess = (feature: string, role?: UserRole): boolean => {
  // For demo purposes, we'll implement a simple feature-based permission system
  switch (feature) {
    case 'dashboard':
      return true; // Everyone has access to dashboard
    case 'admin-panel':
      return isAdmin(role) || isSuperAdmin(role) || isMasterAdmin(role);
    case 'super-admin-panel':
      return isSuperAdmin(role) || isMasterAdmin(role);
    case 'master-admin-panel':
      return isMasterAdmin(role);
    default:
      return false;
  }
};

// Check if the current user can access admin routes
export const canAccessAdminRoutes = (role?: UserRole): boolean => {
  return isAdmin(role) || isSuperAdmin(role) || isMasterAdmin(role);
};

// Check if the current user can access super admin routes
export const canAccessSuperAdminRoutes = (role?: UserRole): boolean => {
  return isSuperAdmin(role) || isMasterAdmin(role);
};
